import Header from "./Header";
import Footer from "./Footer";
import HeroSection from "./HeroSection";
import CTASection from "./CTASection";
import GuildlinePage from "./GuildlinePage";
import "../styles/lannding_page/lannding_page.css";

export default function LandingPage() {
    return (
        <div className="landing-page">
            <Header className="landing-header" padding="0 64px" />
            <main className="landing-main">
                <HeroSection />
                <GuildlinePage />
                <CTASection />
            </main>
            <Footer hideFooter={false} className="landing-footer" />
        </div>
    );
}
